import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import VueGtm from 'vue-gtm'

Vue.use(VueRouter)
// Vue.use(VueGtm, {
//   id: 'GTM-P6NZ4BC',
// });

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/thank-you',
    name: 'Thank You',
    component: () => import(/* webpackChunkName: "about" */ '../views/ThankYou.vue')
  },
  // {
  //   path: '/bm',
  //   name: 'Bahasa Malaysia',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/BahasaMalaysia.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
